const log = (message, title = "DEV LOG:", isWarn, isCriticalError) => {
  let color = "rgba(18, 154, 95, 1)";
  if (isWarn) color = "rgba(241, 171, 39, 1)";
  if (isCriticalError) color = "rgba(225, 5, 5, 1)";
  const style = [
    "padding: 2px 4px;",
    `background-color: transparent;`,
    `border: 2px solid ${color};`,
    "border-radius: 4px;",
    "font-weight: 700;",
    `color: ${color};`,
    "line-height: normal;",
  ].join("");
  if ($LOGS) {
    console.log(`%c${title}`, style);
    !!message && console.log(message);
  }
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

module.exports.setCookie = (cname, cvalue, exdays, iframe) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  const expires = "expires="+ d.toUTCString();
  let cookie = cname + "=" + cvalue + ";" + expires + ";path=/;";
  cookie += iframe ? "SameSite=None;Secure" : "";
  document.cookie = cookie;
}
module.exports.delCookie = (name, domain = '', path = '/') => {
  let cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
  if (domain) cookie += ` domain=${domain};`;
  document.cookie = cookie;
};
module.exports.Modal = class Modal {
  constructor(target) {
    this.body = document.querySelector('body');
    this.modal = document.getElementById(target ? target : 'js-customModal');
  }
  init () {
    if (this.modal) {
      this.listeners();
    }
  }
  listeners () {
    this.modal.addEventListener('click', (e) => {
      this.handleClosing([e.target, e.target.parentNode]);
    });
  }
  handleClosing (targets) {
    targets.forEach(e => {
      if (e.classList.contains('customModal__close')) {
        this.view(false);
      }
    });
  }
  view (status) {
    this.body.style.overflow = status ? 'hidden' : 'unset';
    this.modal.style.display = status ? 'block' : 'none';
  }
}

const customModal = {
  targets: {
    body: document.querySelector('body')
  },
  init: function(target) {
  	this.targets.modal = document.getElementById(target ? target : 'js-customModal');

    if (this.targets.modal) {
      this.listeners();
    }
  },
  listeners: function() {
    this.targets.modal.addEventListener('click', (e) => {
      this.handleClosing([e.target, e.target.parentNode]);
    });
  },
  handleClosing: function(targets) {
    targets.forEach(e => {
      if (e.classList.contains('customModal__close')) {
        this.view(false);
      }
    });
  },
  view: function(status) {
    this.targets.body.style.overflow = status ? 'hidden' : 'unset';
    this.targets.modal.style.display = status ? 'block' : 'none';
  }
}

function emailIsValid(email) {
  const pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return pattern.test(email);
}


module.exports.fadeIn = function (element) {
  let opacity = 0.01;
  element.style.display = "block";
  let timer = setInterval(function() {
    if (opacity >= 1) {
      clearInterval(timer);
    }
    element.style.opacity = opacity;
    opacity += opacity * 0.1;
  }, 5);
}

module.exports.fadeOut = function (element) {
  let op = 1;
  let timer = setInterval(function () {
    if (op <= 0.1){
      clearInterval(timer);
      element.style.display = 'none';
    }
    element.style.opacity = op;
    element.style.filter = 'alpha(opacity=' + op * 100 + ")";
    op -= op * 0.1;
  }, 50);
}

module.exports.hide = function (element) {
  element.style.display = 'none';
}

module.exports.block = function (element) {
  element.style.display = 'block';
}

module.exports.flex = function (element) {
  element.style.display = 'flex';
}

module.exports.getParameterByName = function (name, url) {
  name = name.replace(/[\[\]]/g, '\\$&');
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

module.exports.addDays = function (dateObj, numDays) {
  dateObj.setDate(dateObj.getDate() + numDays);
  return dateObj;
}

module.exports.disableButton = function (status, target) {
  if (status) {
    target.classList.add('disabled');
  } else {
    target.classList.remove('disabled');
  }
}

module.exports.removeParamFromUrl = function (key, sourceURL) {
  let rtn = sourceURL.split("?")[0],
    param,
    params_arr = [],
    queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (let i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

module.exports.checkAuth = function () {
  return localStorage.getItem('emailCollect') || getCookie('h');
}


log(__VERSION__.split("?v=")[1], "CURRENT VERSION: ");

window.customModal = customModal;
window.log = log;
window.emailIsValid = emailIsValid;
module.exports.emailIsValid = emailIsValid;
module.exports.getCookie = getCookie;
